import React, { PureComponent } from 'react';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import { SvgIcon } from 'components/SvgIcon';

interface IProps {
  index: number;
  card: enPaymentMethod;
  selected: any;
  onSelect: (card: enPaymentMethod) => void;
}

export default class CardItem extends PureComponent<IProps> {

  select = () => {
    this.props.onSelect(this.props.card);
  }

  render() {

    const { card, selected, index } = this.props;

    return (
      <div
        id={`brand-${card}-${index}`}
        onClick={this.select}
        className={`chk-flag-option ${card == selected ? 'selected' : null}`}
      >
        <SvgIcon name={`pm_${card}`} />
      </div>);
  }
}